.newCollection {
  padding: 16px;
}
